import { useState, useEffect } from "react";
import moment from "moment";
import InputDate from "../../components/form/InputDate";
import Select from "../../components/form/select/Select";
import ModalDefault from "../../components/ModalDefault";
import api from "../../services/api";
import message from "../../services/message";
import axios from "axios";
import { Container } from "../../styles/layout";
import {
  IconAdd,
  IconArrow,
  IconDetails,
  IconEdit,
  IconFilter,
  IconRemove,
} from "../../components/layout/Svgs";

import {
  HeaderPonto,
  SectionFilterPonto,
  SectionTablePonto,
  SectionDetailsPonto,
  SectionRegisterPonto,
  ContainerPonto,
} from "./styles";
import ButtonDownload from "../../components/form/ButtonDownload/ButtonDownload";
import { ContainerModal, SectionModal } from "../../components/layout/styles";
import Input from "../../components/form/input/Input";





export default function ColaboradoresListar() {

  const [load, setLoad] = useState(false);
  const [modal, setModal] = useState(false);

  const [colaboradores, setColaboradores] = useState([]);
  const [newColaborador, setNewColaborador] = useState({
    colaboradorId:null,
    nome:'',
    rg:'',
    cpf:'',
    email:'',
    status:'ativo'
  })

  useEffect(() => {
    getColaboradores()
  }, [])

  async function getColaboradores(){
    try{
      let response : any =  await api.get(`/colaborador`)
      setColaboradores(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function resetColaborador(){
    setNewColaborador({
      colaboradorId:null,
      nome:'',
      rg:'',
      cpf:'',
      email:'',
      status:'ativo'
    })

    setModal(!modal)
  }


  function handleOnChangeNewColaborador(name: string, value: string) {
    if (value) {
      setNewColaborador({ ...newColaborador, [name]: value });
    } else {
      setNewColaborador({ ...newColaborador, [name]: ''});
    }
  }

  async function editarColaborador(id?: any) {
    
    try{
      if(id){
        let response = await api.get(`/colaborador/${id}`)
        setNewColaborador(response.data)
      }else{
        resetColaborador()
      }
      
      setModal(true);
    } catch(error: any) {
      message.error(String(error?.response?.data?.message));
    }
  }

  async function saveColaborador(e:any){
    try{
      e.preventDefault();
      let response : any
      if(newColaborador.colaboradorId){
        response = await api.put(`/colaborador/${newColaborador.colaboradorId}`,newColaborador)
        message.success(`Colaborador Editado com Sucesso.`)
      }else{
        response = await api.post(`/colaborador`, newColaborador)
        message.success(`Colaborador Criado com sucesso`)
      }
      await getColaboradores()
      resetColaborador()
      setModal(!modal)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function excluirColaborador(id:number){
    try{
      let response : any = await api.delete(`/colaborador/${id}`)
      getColaboradores()

      message.success(`Colaborador Excluido com Sucesso.`)
    
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }



  return (
    <Container>
      <HeaderPonto>
        <h1 className="titlePonto">Colaboradores</h1>
        <button
          style={{ margin: "0px", width: "100px", letterSpacing: "1px",verticalAlign:'middle' }}
          className="btn btn-primary"
          onClick={() => editarColaborador()}
        > 
          Adicionar 
          <i className="fa-solid fa-plus"></i>
        </button>
      </HeaderPonto>



      <SectionTablePonto>
        <table className="default">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>CPF</th>
              <th>RG</th>
              <th>Editar</th>
              <th>Remover</th>
              
            </tr>
          </thead>

          <tbody>

          { colaboradores && colaboradores.length > 0 &&
                colaboradores.map((row:any, key:any) =>(
              <tr key={key}>
        
                <td>{row.nome}</td>
                <td>{row.email}</td>
                <td>{row.cpf}</td>
                <td>{row.rg}</td>
                <td>

                  <button
                    className="btn"
                    onClick={() => editarColaborador(row.colaboradorId)}
                  >
                    <IconEdit />
                  </button>
                </td>
                <td>
                  <button
                    className="btn"
                    onClick={() => excluirColaborador(row.colaboradorId)}
                  >
                    <IconRemove />
                  </button>
                </td>
              </tr>
              ))
            }
          </tbody>
        </table>
      </SectionTablePonto>

      <ModalDefault
        id="modalDefault"
        onClose={() => {resetColaborador()}}
        visible={modal}
      >
        <ContainerModal>
          <SectionModal>
            <h1>Editar / Adicionar - Colaborador</h1>
            <form onSubmit={saveColaborador}>
              <div className="field">
                <h4>Nome</h4>
                <div className="input">
                  <Input name="nome" value={newColaborador.nome} onChange={handleOnChangeNewColaborador}/>
                </div>
              </div>
              <div className="field">
                <h4>RG</h4>
                <div className="input">
                  <Input name="rg" value={newColaborador.rg} onChange={handleOnChangeNewColaborador}/>
                </div>
              </div>
              <div className="field">
                <h4>CPF</h4>
                <div className="input">
                  <Input name="cpf" value={newColaborador.cpf} onChange={handleOnChangeNewColaborador}/>
                </div>
              </div>
              <div className="field">
                <h4>Email</h4>
                <div className="input">
                  <Input name="email" value={newColaborador.email} onChange={handleOnChangeNewColaborador}/>
                </div>
              </div>

              <div className="actions">
                <button type="submit" className="btn btn-success">Salvar</button>
                <button type="button" onClick={() => resetColaborador()} className="btn btn-danger">Voltar</button>
              </div>
            </form>
          
          </SectionModal>
            <button
              className="buttonClosePreview"
              onClick={() => resetColaborador()}
            >
              <IconRemove width="22px" height="22px" />
              Fechar modal
            </button>
          
        </ContainerModal>

      </ModalDefault>
    </Container>
  );
}
